import { useFeatureIsOn } from '@growthbook/growthbook-react';
import React from 'react';
import { RoomRateConfigurationWizardConnected as RoomRateConfigurationWizardV1 } from './container';
import { RoomRateConfigurationWizardV2 } from './v2';

type RoomRateConfigurationWizardVersionProps = {
  bookingStep?: string | string[];
  language: string;
  metaEntity: any;
  entity: {
    type: 'room' | 'rate';
    id?: string | string[];
  };
};

export const RoomRateConfigurationWizardVersion: React.FC<
  RoomRateConfigurationWizardVersionProps
> = ({ bookingStep, entity, ...props }) => {
  const useV2 = useFeatureIsOn('roomrate-v2');
  const normalizedStep = Array.isArray(bookingStep) ? bookingStep[0] : bookingStep;
  const normalizedEntity = {
    type: entity.type,
    id: Array.isArray(entity.id) ? entity.id[0] : entity.id ?? '',
  };
  if (useV2)
    return (
      <RoomRateConfigurationWizardV2
        bookingStep={normalizedStep}
        entity={normalizedEntity}
        {...props}
      />
    );
  return (
    <RoomRateConfigurationWizardV1
      bookingStep={normalizedStep}
      entity={normalizedEntity}
      {...props}
    />
  );
};
